"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'DD/MM/AAAA': {
    // Catala, Espanol
    year: 'AAAA'
  },
  'DD/MM/ÅÅÅÅ': {
    // Dansk
    year: 'ÅÅÅÅ'
  },
  'DD.MM.JJJJ': {
    // Deutsch
    year: 'JJJJ'
  },
  'AAAA-MM-JJ': {
    // Francais (CA)
    day: 'JJ',
    year: 'AAAA'
  },
  'GG/MM/AAAA': {
    // Italiano
    day: 'GG',
    year: 'AAAA'
  },
  'MM/DD/RRRR': {
    // Polszczyzna
    year: 'RRRR'
  },
  'KK/PP/VVVV': {
    // Suomen Kieli
    day: 'KK',
    month: 'PP',
    year: 'VVVV'
  },
  'ดด/วว/ปปปป': {
    // ภาษาไทย
    day: 'ดด',
    month: 'วว',
    year: 'ปปปป',
    splitCharacter: '/' // js doesn't recognize any of the arabic characters as non speical characters

  }
};
exports.default = _default;